import { Converter } from '../types/converter';

export const accelerationAngularConverter: Converter = {
  id: 'accelerationAngular',
  name: 'Angular Acceleration Converter',
  icon: 'RotateCcw',
  categories: ['engineering', 'physics'],
  units: [
    // Base unit
    { name: 'Radian/square second', symbol: 'rad/s²', factor: 1 },
    
    // Time variations
    { name: 'Radian/square minute', symbol: 'rad/min²', factor: 1/3600 },  // (1/60)²
    
    // Revolution-based units
    { name: 'Revolution/square second', symbol: 'rev/s²', factor: 6.283185307179586 },  // 2π
    { name: 'Revolution/minute/second', symbol: 'rev/min·s', factor: 0.10471975511965977 },  // 2π/60
    { name: 'Revolution/square minute', symbol: 'rev/min²', factor: 0.0017453292519943296 }  // 2π/3600
  ]
};
